export default __webpack_public_path__ + "static/Artboard-10-8dca181d9c0a78b02835e1c0e5247884.webp";